import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../services/common.service';
import { WebStorageService } from '../../services/web-storage.service';
import { NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.css'],
    imports: [NgIf, NgClass]
})
export class PrivacyPolicyComponent implements OnInit ,OnChanges{
  @Input() privacyPolicyModal : boolean = true;
  submitted = false;
  @Output() closeModal = new EventEmitter();
  @Output() openModal = new EventEmitter();
  user!: { [key: string]: any };
  isDisabled = false;
  @Input() isCancelOption = false;
  apiProcessing = false;
  isPendingSignature = false;
  signature!: string;
  @Output() requestLogout = new EventEmitter<boolean>();
  @Output() userData = new EventEmitter<any>();
  docUrl: any;

  /**
   * constructor
   */
  constructor(
    private toastr: ToastrService,
    private webStorageService: WebStorageService,
    public commonService: CommonService
  ) { }

  ngOnInit() {
    // console.log('privacy policy component');
    this.user = this.webStorageService.getLocalStorage('user') != null ? JSON.parse(this.webStorageService.getLocalStorage('user') || 'undefined') : this.user;
    // this.commonService.getDocument();
    this.commonService.getDocument().subscribe({
        next: (docUrls) => {
            this.docUrl = docUrls;
        },
        error: (err) => {
            console.error('Error fetching documents:', err);
        }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['privacyPolicyModal'].currentValue) this.privacyPolicyModal = changes['privacyPolicyModal'].currentValue
  }


  /**
   * Closes privecymodal
   */
  closePrivecyModal() {
    this.closeModal.emit();
    this.requestLogout.emit(true);
  }

  /**
   * Triggers signature retrieval
   */
  triggerSignatureRetrieval(): void {
    this.refreshUser();
    if (!this.user) {
      this.toastr.error('User session not found. Please log in again.');
      return;
    }
    if (this.user['signature']) {
      this.isPendingSignature = true;
      this.submitted = true;
      this.commonService.getSignature().then(signature => {
        this.signature = signature;
        this.isPendingSignature = false;
        const payload = {
          is_policy_accepted: true,
          signature: this.signature
        };
        this.callUpdatePolicyStatus(payload);

      }).catch((error) => {
        this.isPendingSignature = false;
        this.submitted =false
        this.toastr.error('Please agree to sign the privacy policy and user aggrement to proceed.')
      })
    } else {
      const payload = {
        is_policy_accepted: true
      };
      this.callUpdatePolicyStatus(payload);
    }
  }

  /**
   * Calls update policy status
   * @param payload 
   */
  private refreshUser(): void {
    const stored = this.webStorageService.getLocalStorage('user');
    this.user = stored != null ? JSON.parse(stored) : this.user;
  }

  callUpdatePolicyStatus(payload: any): void {
    this.submitted = true;
    this.commonService.updatePolicyStatus(this.user['_id'], payload).subscribe({
      next: (response: any) => {
        this.submitted = false;
        this.toastr.success(response.message);
        this.submitted = false;
        this.userData.emit({data: response?.data,updateKey:'privacy_policy'});
        this.privacyPolicyModal =false;
        this.closeModal.emit();
      },
      error: (err: HttpErrorResponse) => {
        this.isPendingSignature = false;
        this.submitted = false;
        console.error(err)
      }
    });
  }


}
